import { AxiosRequestConfig } from "axios";
import ApiClient from "../../../services/apiClient";

export const community = (
  account: string,
  projectId: string,
  opts?: AxiosRequestConfig
) => ApiClient.get(`/account/${account}/project/${projectId}/community`, opts);
